module.exports = __webpack_public_path__ + "static/media/ci_sort-ascending.2e212672.svg";